import { createFileRoute } from '@tanstack/react-router';
import { advertiserStaticData } from '../../advertiser';

export const Route = createFileRoute('/_private-routes/advertiser/$id/budget-allocation')({
  staticData: advertiserStaticData
});
